export default __webpack_public_path__ + "static/media/00.f1e4590b.png";